import React, { useState } from 'react'
import TabCredForm from './tabSetting/TabCredForm'
import TabLogoImg from '../../../../../../assets/static/images/tab_logo.png'

export default function TabCredFailed() {
  const [tabPopUpStatus, setTabPopUpStatus] = useState('')

  return (
    <div className={`support-pop-up-align pop-up-align bg-white shadow-lg m-4 border-radius-10 ${tabPopUpStatus == 'close' ? 'd-none' : ''}`}>
      <div className='bg-primary p-4 top-primary-bar d-flex justify-content-between'>
        <h6 className='text-white'>Failed TAB Credentials</h6>
        <i className='la la-times font-size-18 text-white' onClick={() => setTabPopUpStatus('close')} />
      </div>
      <div className='p-4'>
        {tabPopUpStatus !== 'credUpdate' && <>
          <div className='d-flex align-items-center'>
            <img src={TabLogoImg} className='width-4' />
            <h6 className='text-danger mb-0 font-size-18 ml-2'>TAB credentials could not be verified. Please Update.</h6>
          </div>
          <div className='d-flex justify-content-center'>
            <button className='btn btn-primary btn-sm my-6' type='button' onClick={() => setTabPopUpStatus('credUpdate')}>Update TAB Credentials</button>
          </div>
        </>}
        {tabPopUpStatus == 'credUpdate' && <TabCredForm setTabPopUpStatus={setTabPopUpStatus} isPopUp={true} />}
      </div>
    </div>
  )
}
